import gql from 'graphql-tag';

export default gql`
  fragment salesforceAccountRecordTypeFragment on SalesforceAccountRecordType {
    id
    name
    recordTypeId
    isMaster
  }
`;
